(() => {
  const header = document.querySelector('[data-tlx-global-header]');
  if (!header || header.dataset.ready === 'true') return;
  header.dataset.ready = 'true';

  const button = header.querySelector('[data-tlx-global-menu-toggle]');
  const navigation = header.querySelector('[data-tlx-global-mobile-navigation]');
  if (!button || !navigation) return;

  const setMenu = (open) => {
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute(
      'aria-label',
      open ? button.dataset.closeLabel : button.dataset.openLabel,
    );
    navigation.setAttribute('aria-hidden', String(!open));
    navigation.classList.toggle('tlx-global-mobile-navigation--open', open);
    button.classList.toggle('tlx-global-menu-button--open', open);
    document.body.classList.toggle('tlx-global-menu-open', open);
  };

  button.addEventListener('click', () => {
    setMenu(button.getAttribute('aria-expanded') !== 'true');
  });

  navigation.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) setMenu(false);
  });
})();
